import React from 'react';
import './Header.css';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { removeToken, getToken } from '../../Services/LocalStorageService';



import LogoutIcon from '@mui/icons-material/Logout';
import HomeIcon from '@mui/icons-material/Home';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import BadgeIcon from '@mui/icons-material/Badge';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import PaymentsIcon from '@mui/icons-material/Payments';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import ListAltIcon from '@mui/icons-material/ListAlt';
import VisibilityIcon from '@mui/icons-material/Visibility';
import AssessmentIcon from '@mui/icons-material/Assessment';

function Header() {
  const navigate = useNavigate();
  const { access_token } = getToken();

  const handleLogout = () => {
    removeToken();
    navigate('/');
  };

  const location = useLocation();

  // const iconItems = [
  //   // { to: "/Dashboard", icon: <HomeIcon />, label: "Home" }, // Home first
  //   // middle icons
  //   { to: "/addclients", label: "Client" },
  //   { to: "/lifter-user", label: "Lifter" },
  //   { to: "/staff-user",  label: "Staff" },
  //   { to: "/entry_do_no",  label: "Do No" },
  //   { to: "/lifter-assign-view", label: "Lifter DO" },
  //   { to: "/lifter-dispatch-view", label: "Dispatch" },
  //   { to: "/freight-pay",  label: "Freight Pay" },
  //   { to: "/lifter-payment-view",  label: "Lifter Pay" },
  //   { to: "/party-payment-view", label: "Party Pay" },
  //   { to: "/Order_form", label: "Today Order" },
  //   { to: "/all_order", label: "All Orders" },
  //   { to: "/bill-view", label: "Bill View" },
  //   { to: "/reports-view", label: "Reports" },
  // ];

  if (access_token) {
    // Add logout at the end
    // iconItems.push({
    //   to: "#",
    //   icon: <LogoutIcon onClick={handleLogout} />,
    //   label: "Logout"
    // });
  }

  
   
}


function DashboardIcon({ to, icon, label, isLogout, isActive }) {
  return (
    <div className={`dashboard-icon ${isActive ? "active-tab" : ""}`}>
      {isLogout ? (
        <div className="icon-link" onClick={icon.props.onClick}>
          {icon}
          <div className="icon-label">{label}</div>
          
        </div>
      ) : (
        <Link to={to} className="icon-link">
          {icon}
          <div className="icon-label">{label}</div>
        </Link>
      )}
    </div>
  );
}


export default Header;


